import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-title-bg",
  "use": "icon-title-bg-usage",
  "viewBox": "0 0 98 29",
  "content": "<symbol viewBox=\"0 0 98 29\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-title-bg\">\n<path d=\"M5 10.3989C16 12.125 38 12.6 56.5263 5C51.3158 15.45 38.5789 24 38.5789 24C49.5789 17.35 77.9474 15.45 93 19.7021\" stroke=\"currentColor\" stroke-width=\"10\" stroke-linecap=\"round\" stroke-linejoin=\"round\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol